module.exports = __webpack_public_path__ + "img/serviceState6.176fa09f.svg";